import { render } from "./typeList.vue?vue&type=template&id=0bf4da0a&scoped=true"
import script from "./typeList.vue?vue&type=script&lang=js"
export * from "./typeList.vue?vue&type=script&lang=js"

import "./typeList.vue?vue&type=style&index=0&id=0bf4da0a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0bf4da0a"

export default script